require('styles/Calendar.css');

import React from 'react';

class Calendar extends React.Component {
  render() {
    return (
      <div className="row">
        <div className="calendar">
          <div title="Add to Calendar" className="addeventatc my-green darken-2 btn">
            Přidat do kalendáře
            <i className="material-icons left">event</i>
            <span className="start">05/05/2018 01:00 PM</span>
            <span className="end">05/06/2018 12:00 AM</span>
            <span className="timezone">Europe/Prague</span>
            <span className="title">Evča a Kuba - Svatba</span>
            <span className="description">Více na http://svatba.kinst.cz</span>
            <span className="location">Statek Benice, Benice 1, Chrášťany</span>
          </div>
        </div>
      </div>
    )
  }
}

Calendar.defaultProps = {};

export default Calendar;



// WEBPACK FOOTER //
// ./src/components/Calendar.js